import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import { Mail } from '@eb/eds-iconography';

import NotificationScreen from '../../components/NotificationScreen';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOFT_ACCOUNT_STATUS_PATH
 */
export default class SoftAccountStatusPage extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
    };

    render() {
        const { email } = this.props;
        const iconType = <Mail />;
        const headerText = gettext('Check your email');

        let subtitleText = gettext(
            "Looks like you're already in our system! Check your email to create a new password.",
        );

        //Need to conditionally check if the email is present and update copy accordingly
        //in case the user refreshes the notification page and we lose the email from state.
        if (email) {
            subtitleText = gettext(
                "Looks like you're already in our system! Check your email at %(email)s to create a new password.",
                { email },
            );
        }

        return (
            <div className="eds-l-mar-vert-14">
                <NotificationScreen
                    iconType={iconType}
                    headerText={headerText}
                    subtitleText={subtitleText}
                />
            </div>
        );
    }
}
